import { CartItem } from "modules/cart/types/cart";
import { endPointCartMigrate } from "modules/main/services/endpoints";
import apiClient from "modules/main/services/apiClient";

/**
 * Request payload for cart migration API.
 */
export interface MigrateCartRequest {
  version: number;
  products: CartItem[];
}

/**
 * Response from cart migration API.
 */
export interface MigrateCartResponse {
  status: "migrated" | "current";
  products?: CartItem[];
}

/**
 * Migrates cart products from legacy integer IDs to UUID format.
 * @param version - Current cart version from localStorage "v"
 * @param products - Current cart items to migrate
 * @returns Response with status and optionally migrated products
 */
export const migrateCart = async (
  version: number,
  products: CartItem[]
): Promise<MigrateCartResponse> => {
  try {
    const response = await apiClient.post<MigrateCartResponse>(
      endPointCartMigrate,
      { version, products }
    );
    return response;
  } catch (error) {
    // Log to telemetry, allow retry on next mount
    console.warn(
      "[migrateCart] Migration failed, will retry on next mount:",
      error
    );
    return { status: "current" };
  }
};